export default __webpack_public_path__ + "static/media/room4.f1194396.jpg";